/* eslint-disable no-undefined */
import React, { useRef } from "react";
import PropTypes from "prop-types";
// Mui imports > move to modern
import MenuItem from "@mui/material/MenuItem";
import ListItemText from "@mui/material/ListItemText";
// Limitless Imports
import { useAppConfig } from "@limitless/common/hooks";
import { recordPageView } from "@limitless/analytics";
import { useNavigation } from "../../hooks/navigation/NavigationContext";
import { useGuideDrawer } from "../../hooks/guide-drawer/GuideDrawerHook";
import { useTranslation } from "@limitless/common/hooks";
import HelpPanel from "../../components/help-panel/HelpPanel";
import HelpHighlightPopper from "../../components/poppers/help-highlight-popper/HelpHighlightPopper";
import { useExpertSupportConversationHistoryContext } from "@limitless/expert";
// Modern Imports
import IconButton from "@limitless/modern/inputs/icon-button/IconButton";
import Menu from "@limitless/modern/navigation/menu/Menu";
import Divider from "@limitless/modern/data-display/divider/Divider";
import WebSocketDebugDrawer from "./WebSocketDebugDrawer";
import Badge from "@limitless/modern/feedback/badge/Badge";
// Icon Imports
import HelpIcon from "@limitless/icons/QuestionCircle";
const HelpMenu = ({
  helpDrawerAvailable
}) => {
  const [showWebSocketDebugDrawer, setShowWebSocketDebugDrawer] = React.useState(false);
  const [helpMenuAnchorEl, setHelpMenuAnchorEl] = React.useState(null);
  const helpMenuOpen = Boolean(helpMenuAnchorEl);
  const {
    toggleGuide,
    isGuideOpen
  } = useGuideDrawer();
  const {
    navigate
  } = useNavigation();
  const {
    t
  } = useTranslation();
  const buttonRef = useRef();
  const {
    getFeatureSwitches,
    getContactUsUrl
  } = useAppConfig();
  const {
    webSocketDebug
  } = getFeatureSwitches();
  const {
    unReadMessageCount
  } = useExpertSupportConversationHistoryContext();
  const handleHelpMenuClick = event => {
    setHelpMenuAnchorEl(event.currentTarget);
  };
  const handleHelpMenuClose = () => {
    setHelpMenuAnchorEl(null);
  };
  const handleOpenLimitlessGuideClick = () => {
    toggleGuide();
    recordPageView("Limitless Guide", location.pathname);
  };
  const handleContactUsClick = () => {
    const navigationPath = "/contactusscreen";
    const url = getContactUsUrl(navigationPath);
    if (url === navigationPath) {
      navigate(url);
    } else {
      window.open(url, "_blank");
    }
    handleHelpMenuClose();
  };
  return /*#__PURE__*/React.createElement("div", {
    ref: buttonRef
  }, /*#__PURE__*/React.createElement(IconButton, {
    icon: /*#__PURE__*/React.createElement(Badge, {
      content: /*#__PURE__*/React.createElement(HelpIcon, null),
      count: unReadMessageCount,
      name: "Help"
    }),
    label: "",
    id: "help-icon-button",
    "aria-controls": helpMenuOpen ? "help-menu" : undefined,
    "aria-haspopup": "true",
    "aria-expanded": helpMenuOpen ? "true" : undefined,
    onClick: handleHelpMenuClick
  }), /*#__PURE__*/React.createElement(Menu, {
    id: "help-menu",
    anchorEl: helpMenuAnchorEl,
    open: helpMenuOpen,
    onClose: handleHelpMenuClose,
    MenuListProps: {
      "aria-labelledby": "help-icon-button"
    }
  }, /*#__PURE__*/React.createElement(MenuItem, null, /*#__PURE__*/React.createElement(ListItemText, {
    secondary: t("Help")
  })), helpDrawerAvailable && /*#__PURE__*/React.createElement(MenuItem, {
    id: "guideNavItem",
    onClick: () => {
      handleOpenLimitlessGuideClick();
      handleHelpMenuClose();
    }
  }, /*#__PURE__*/React.createElement(ListItemText, {
    primary: t("Open Limitless Guide")
  })), /*#__PURE__*/React.createElement(MenuItem, {
    id: "tutorialsNavItem",
    onClick: () => {
      navigate("/tutorials", false, [{
        text: "Tutorials"
      }]);
      handleHelpMenuClose();
    }
  }, /*#__PURE__*/React.createElement(ListItemText, {
    primary: t("Tutorial Videos")
  })), /*#__PURE__*/React.createElement(MenuItem, {
    id: "faqsNavItem",
    onClick: () => {
      navigate("/knowledge", false, [{
        text: "Knowledge"
      }]);
      handleHelpMenuClose();
    }
  }, /*#__PURE__*/React.createElement(ListItemText, {
    primary: t("FAQs")
  })), /*#__PURE__*/React.createElement(MenuItem, {
    id: "contactNavItem",
    onClick: handleContactUsClick
  }, /*#__PURE__*/React.createElement(ListItemText, {
    primary: t("Contact Us")
  })), webSocketDebug && /*#__PURE__*/React.createElement(MenuItem, {
    id: "webSocketDebugItem",
    onClick: () => {
      setShowWebSocketDebugDrawer(true);
      handleHelpMenuClose();
    }
  }, /*#__PURE__*/React.createElement(ListItemText, {
    primary: t("Web Socket Debug")
  })), /*#__PURE__*/React.createElement(Divider, null), /*#__PURE__*/React.createElement(MenuItem, null, /*#__PURE__*/React.createElement(ListItemText, {
    secondary: t("Legal")
  })), /*#__PURE__*/React.createElement(MenuItem, {
    id: "termsNavItem",
    onClick: () => {
      navigate("/legal");
      navigate("/legal/0");
      handleHelpMenuClose();
    }
  }, /*#__PURE__*/React.createElement(ListItemText, {
    primary: t("Terms & Conditions")
  })), /*#__PURE__*/React.createElement(MenuItem, {
    id: "privacyNavItem",
    onClick: () => {
      navigate("/legal");
      navigate("/legal/1");
      handleHelpMenuClose();
    }
  }, /*#__PURE__*/React.createElement(ListItemText, {
    primary: t("Privacy Policy")
  })), /*#__PURE__*/React.createElement(MenuItem, {
    id: "conductNavItem",
    onClick: () => {
      navigate("/legal");
      navigate("/legal/2");
      handleHelpMenuClose();
    }
  }, /*#__PURE__*/React.createElement(ListItemText, {
    primary: t("Code of Conduct")
  })), /*#__PURE__*/React.createElement(MenuItem, {
    id: "idtaNavItem",
    onClick: () => {
      navigate("/legal");
      navigate("/legal/3");
      handleHelpMenuClose();
    }
  }, /*#__PURE__*/React.createElement(ListItemText, {
    primary: t("International Data Transfer Addendum")
  }))), /*#__PURE__*/React.createElement(HelpHighlightPopper, {
    buttonRef: buttonRef.current,
    icon: HelpIcon
  }), /*#__PURE__*/React.createElement(HelpPanel, {
    showHelp: isGuideOpen,
    setShowHelp: toggleGuide
  }), showWebSocketDebugDrawer && /*#__PURE__*/React.createElement(WebSocketDebugDrawer, {
    onClose: () => setShowWebSocketDebugDrawer(false)
  }));
};
HelpMenu.propTypes = {
  helpDrawerAvailable: PropTypes.bool
};
export default HelpMenu;